import { gsap, Power1, Power4 , Power2, Power3} from "gsap";
$ = jQuery;






export function write($el) {
    if ($el.hasClass("word")) {
        var speed = 140;
        var c = "st";
    } else if ($el.hasClass("letter")) {
        var speed = 30;
        var c = "s";
    }
    var speedAttr = $el.attr('speed');
    if (typeof speedAttr !== typeof undefined && speedAttr !== false) {
        var speed = speedAttr;
    }
    var lines = false;
    if ($el.hasClass("lines")) {
        var lines = true;
    }
    $("span", $el).each(function (i, v) {
        if (lines) {
            var thisHeight = $(this).height();
            var containerOffset = $(this).offset().top - $el.offset().top;
            var line = Math.floor(containerOffset / thisHeight);
            setTimeout(function () {
                $("span:nth-child(" + (i + 1) + ")", $el).addClass(c);
            }, line * speed);
        } else {
            setTimeout(function () {
                $("span:nth-child(" + (i + 1) + ")", $el).addClass(c);
            }, i * speed);
        }
    });
}

